import { ChangeDetectionStrategy, Component, output, OutputEmitterRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'matte-toggle-button',
  imports: [MatSlideToggleModule, ReactiveFormsModule],
  templateUrl: './matte-toggle-button.component.html',
  styleUrl: './matte-toggle-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatteToggleButtonComponent {
  public matteChange: OutputEmitterRef<boolean> = output<boolean>();

  public control = false;

  public onChange(e: any): void {
    this.control = e.checked;
    this.matteChange.emit(this.control);
  }
}
